import AUD from './currency-svgs/australia_flag.svg';
import BGN from './currency-svgs/bulgaria_flag.svg';
import CAD from './currency-svgs/canada_flag.svg';
import CNY from './currency-svgs/china_flag.svg';
import CZK from './currency-svgs/czech_rep_flag.svg';
import DKK from './currency-svgs/denmark_flag.svg';
import EUR from './currency-svgs/eur_flag.svg';
import GBP from './currency-svgs/gb_flag.svg';
import HKD from './currency-svgs/hong_kong_flag.svg';
import HUF from './currency-svgs/hungary_flag.svg';
import ILS from './currency-svgs/israel_flag.svg';
import JPY from './currency-svgs/japan_flag.svg';
import KRW from './currency-svgs/korea_flag.svg';
import MOP from './currency-svgs/macau_flag.svg';
import MYR from './currency-svgs/malaysia_flag.svg';
import MAD from './currency-svgs/morocco_flag.svg';
import NZD from './currency-svgs/new_zealand_flag.svg';
import NOK from './currency-svgs/norway_flag.svg';
import RON from './currency-svgs/romania_flag.svg';
import SGD from './currency-svgs/singapore_flag.svg';
import SEK from './currency-svgs/sweden_flag.svg';
import CHF from './currency-svgs/switzerland_flag.svg';
import TWD from './currency-svgs/taiwan_flag.svg';
import TRY from './currency-svgs/turkey_flag.svg';
import AED from './currency-svgs/uae_flag.svg';
import USD from './currency-svgs/us_flag.svg';

const CURRENCY_ICONS = {
  AED,
  AUD,
  BGN,
  CAD,
  CHF,
  CNY,
  CZK,
  DKK,
  EUR,
  GBP,
  HKD,
  HUF,
  ILS,
  JPY,
  KRW,
  MAD,
  MOP,
  MYR,
  NOK,
  NZD,
  RON,
  SEK,
  SGD,
  TRY,
  TWD,
  USD,
} as const;

export const getCurrencyIcon = (currency: string | null) => {
  if (!currency) return '';
  return CURRENCY_ICONS[currency as keyof typeof CURRENCY_ICONS] || '';
};
